import { registerTheme } from '../../theme';
import { DEFAULT_BAR_THEME } from '../bar/theme';

registerTheme('stackedBar', DEFAULT_BAR_THEME);
